import PropTypes from "prop-types";
import { TRANSLATION_KEY_CATEGORY_CAROUSEL } from "./constants";
import CarouselWrapper from "./components/CarouselWrapper";

const HorizontalScrollList = ({
  children,
  className,
  isCentralised = true,
  scrollSnapping = false,
  ariaLabel = TRANSLATION_KEY_CATEGORY_CAROUSEL
}) => (
  <CarouselWrapper
    scrollSnapping={scrollSnapping}
    className={className}
    ariaLabel={ariaLabel}
    isCentralised={isCentralised}
  >
    {children}
  </CarouselWrapper>
);

HorizontalScrollList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isCentralised: PropTypes.bool,
  scrollSnapping: PropTypes.bool,
  ariaLabel: PropTypes.string
};

export default HorizontalScrollList;
